import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, ButtonProps } from '@/ui/button'
import { useWallet } from './use-wallet'

export type WalletDisconnectButtonProps = Omit<ButtonProps, 'onClick'>

/**
 * Кнопка отключения TON кошелька
 */
const WalletDisconnectButton = forwardRef<
  HTMLButtonElement,
  WalletDisconnectButtonProps
>(({ children, ...props }, ref) => {
  const { t } = useTranslation('app')
  const { disconnect } = useWallet()

  return (
    <Button ref={ref} {...props} onClick={disconnect}>
      {children || t('wallet_connect.disconnect_button')}
    </Button>
  )
})

WalletDisconnectButton.displayName = 'WalletDisconnectButton'

export { WalletDisconnectButton }
